<template>
    <b-card :title="title">
        <b-row>
            <b-col>
                <b-row>
                    <b-col>
                      <b-form-group
                          label-cols-sm="4"
                          label="Addressbook"
                          label-align-sm="left"
                      >
                        <b-input-group>
                          <b-col sm="11">
                            <v-select
                                :options="filteredAddressBook"
                                :dynamicWidth="true"
                                label="name"
                                placeholder="Search Addressbook"
                                v-model="selectedAddressId"
                                @input="fillAddressFields"
                                style="width: 100%;"
                            ></v-select>
                          </b-col>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.CompanyName')"
                            label-align-sm="left"
                        >
                            <b-input-group>
                                <b-col sm="11">
                                    <b-form-input
                                        :class="{ 'is-invalid': v.name.$error }"
                                        size="sm"
                                        :name="`${prefix}-companyName`"
                                        v-model="address.name"
                                        @update="v.name.$touch()"
                                    ></b-form-input>
                                </b-col>
                                <b-input-group-append>
                                    <font-awesome-icon
                                        icon="exclamation-circle"
                                        size="lg"
                                    />
                                </b-input-group-append>
                            </b-input-group>
                            <validationField
                                :fieldName="'Company name'"
                                v-if="v.name.$dirty"
                                :validator="v.name"
                            ></validationField>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.Address')"
                            label-align-sm="left"
                        >
                            <b-input-group>
                                <b-col sm="11">
                                    <b-form-input
                                        :class="{ 'is-invalid': v.street1.$error }"
                                        size="sm"
                                        :name="`${prefix}-street1`"
                                        v-model="address.street1"
                                        @update="v.street1.$touch()"
                                    ></b-form-input>
                                </b-col>
                                <b-input-group-append>
                                    <font-awesome-icon
                                        icon="exclamation-circle"
                                        size="lg"
                                    />
                                </b-input-group-append>
                            </b-input-group>
                            <validationField
                                :fieldName="'Address'"
                                v-if="v.street1.$dirty"
                                :validator="v.street1"
                            ></validationField>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.Address')"
                            label-align-sm="left"
                        >
                            <b-input-group>
                                <b-col sm="11">
                                    <b-form-input
                                        :name="`${prefix}-street2`"
                                        v-model="address.street2"
                                        size="sm"
                                    ></b-form-input>
                                </b-col>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.Address')"
                            label-align-sm="left"
                        >
                            <b-col sm="11">
                                <b-form-input
                                    v-model="address.street3"
                                    :name="`${prefix}-street3`"
                                    size="sm"
                                ></b-form-input>
                            </b-col>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.City')"
                            label-align-sm="left"
                        >
                            <b-input-group>
                                <b-col sm="11">
                                    <b-form-input
                                        :class="{ 'is-invalid': v.city.$error }"
                                        size="sm"
                                        v-model="address.city"
                                        :name="`${prefix}-city`"
                                        @update="v.city.$touch()"
                                    ></b-form-input>
                                </b-col>
                                <b-input-group-append>
                                    <font-awesome-icon
                                        icon="exclamation-circle"
                                        size="lg"
                                    />
                                </b-input-group-append>
                            </b-input-group>
                            <validationField
                                :fieldName="'City'"
                                v-if="v.city.$dirty"
                                :validator="v.city"
                            ></validationField>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.PostalCode')"
                            label-align-sm="left"
                        >
                            <b-col sm="11">
                                <b-form-input
                                    :name="`${prefix}-postalCode`"
                                    size="sm"
                                    v-model="address.postalCode"
                                ></b-form-input>
                            </b-col>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.Country')"
                            label-align-sm="left"
                            :reduce="(country) => country.countryCode"
                        >
                            <b-input-group>
                                <b-col sm="11">
                                    <vSelect
                                        :dynamicWidth="true"
                                        v-model="address.countryCode"
                                        :placeholder="$t('createInvoice.placeholder.ChooseCountry')"
                                        :options="getCountries"
                                        label="countryName"
                                        :name="`${prefix}-countryCode`"
                                        :reduce="(country) => country.countryCode"
                                        :class="{ 'is-invalid': v.countryCode.$error }"
                                        @update="v.contryCode.touch()"
                                    />
                                </b-col>
                                <b-input-group-append>
                                    <font-awesome-icon
                                        icon="exclamation-circle"
                                        size="lg"
                                    />
                                </b-input-group-append>
                                <validationField
                                    :fieldName="'Country'"
                                    v-if="v.countryCode.$dirty"
                                    :validator="v.countryCode"
                                ></validationField>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.Phone')"
                            label-align-sm="left"
                        >
                            <b-col sm="11">
                                <b-form-input
                                    size="sm"
                                    v-model="address.contactPerson.phone"
                                    :name="`${prefix}-phoneNumber`"
                                ></b-form-input>
                            </b-col>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.Email')"
                            label-align-sm="left"
                        >
                            <b-col sm="11">
                                <b-form-input
                                    size="sm"
                                    :name="`${prefix}-email`"
                                    v-model="address.contactPerson.mails[0]"
                                ></b-form-input>
                            </b-col>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.ContactPerson')"
                            label-align-sm="left"
                        >
                            <b-col sm="11">
                                <b-form-input
                                    size="sm"
                                    v-model="address.contactPerson.name"
                                    :name="`${prefix}-contactPersonName`"
                                ></b-form-input>
                            </b-col>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.VatNumber')"
                            label-align-sm="left"
                        >
                            <b-col sm="11">
                                <b-form-input
                                    :name="`${prefix}-vatNumber`"
                                    size="sm"
                                    v-model="address.vatNumber"
                                ></b-form-input>
                            </b-col>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group
                            label-cols-sm="4"
                            :label="$t('createInvoice.label.EuriNumber')"
                            label-align-sm="left"
                        >
                          <b-input-group>
                            <b-col sm="11">
                                <b-form-input
                                    :name="`${prefix}-euriNumber`"
                                    size="sm"
                                    v-model="address.euriNumber"
                                ></b-form-input>
                            </b-col>
                          <b-input-group-append v-if="address.requireEori">
                            <font-awesome-icon
                                icon="exclamation-circle"
                                size="lg"
                            />
                          </b-input-group-append>
                            <validationField
                                :fieldName="'Euri number'"
                                v-if="v.euriNumber.$dirty"
                                :validator="v.euriNumber"
                            ></validationField>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
  import vSelect from '../vSelect';
  import { mapGetters } from 'vuex';
  import validationField from '../Validation/ValidationField';

  export default {
      components: {
          vSelect,
          validationField,
      },
      props: {
          v: { required: true },
          title: {
              type: String,
          },
          address: {
              type: Object,
          },
          prefix: {
              type: String,
              required: true,
          },
          addressBookType: { type: String, default: null }
      },
      data() {
          return {
              selectedCountry: null,
              selectedAddressId: null,
          };
      },
      methods: {
        fillAddressFields(selected) {
          if (!selected) return;
          this.address.name = selected.name || '';
          this.address.street1 = selected.street1 || '';
          this.address.street2 = selected.street2 || '';
          this.address.street3 = selected.street3 || '';
          this.address.city = selected.city || '';
          this.address.postalCode = selected.postalCode || '';
          this.address.countryCode = selected.countryCode || '';
          this.address.contactPerson = {
            name: (selected.contactPerson && selected.contactPerson.name) || '',
            phone: (selected.contactPerson && selected.contactPerson.phone) || '',
            mails: [(selected.contactPerson && selected.contactPerson.mails && selected.contactPerson.mails[0]) || ''],
          };
          this.address.vatNumber = selected.vatNumber || '';
          this.address.euriNumber = selected.euriNumber || '';
        },
      },
    computed: {
          ...mapGetters('core', ['getCountries']),
          ...mapGetters('createShipment', ['getAddressBook']),

      filteredAddressBook() {
        let result = this.getAddressBook || [];

        if (this.invoice && this.invoice.companyId) {
          result = result.filter((entry) => entry.companyId === this.invoice.companyId);
        }

        if (this.addressBookType === 'SoldTo') {
          result = result.filter(
              (a) => a.addressType === 'SoldTo' || a.addressType === 'AddressBook' || a.addressType === null
          );
        } else if (this.addressBookType === 'AddressBook') {
          result = result.filter((a) => a.addressType === 'AddressBook' || a.addressType === null);
        }
        return result;
      }
    },
  };
</script>

<style></style>
